const createData = (translations) => [
    {
      id: 1,
      category: "education",
      icon: "icon-graduation",
      year: translations.education1Date,
      title: translations.education1Title,
      desc: translations.education1Desc,
    },
    {
      id: 2,
      category: "education",
      icon: "icon-graduation",
      year: translations.education2Date,
      title: translations.education2Title,
      desc: translations.education2Desc,
    },
    {
      id: 3,
      category: "experience",
      icon: "icon-briefcase",
      year: translations.career1Date,
      title: translations.career1Title,
      desc: translations.career1Desc,
    },
    {
      id: 4,
      category: "experience",
      icon: "icon-briefcase",
      year: translations.career2Date,
      title: translations.career2Title,
      desc: translations.career2Desc,
    },
    {
      id: 5,
      category: "experience",
      icon: "icon-briefcase",
      year: translations.career3Date,
      title: translations.career3Title,
      desc: translations.career3Desc,
    },
];

export default createData